export default "__VITE_ASSET__DM18GPev__"